import { Typography } from 'palette/Typography';
import { formatLargeWholeNumberGaps } from '@helpers/text';

import '../styles/LeftNavigationItemCount.scss';

export function LeftNavigationItemCount({
    selected,
    productCount
}) {
    return (
        <Typography
            className="left-navigation-item-count"
            color={selected ? 'strong' : 'light'}
            tagName="span"
            type="small"
        >
            {formatLargeWholeNumberGaps(productCount)}
        </Typography>
    );
}
